export default "__VITE_ASSET__da0Ni8VT__"